module.exports = __webpack_public_path__ + "static/scale-model-of-boomerang-line-in-cleveland-ohio-5a6f60f8980ffbe295fb105fb8a6d8be.png";